import React from 'react'
import { Link } from 'gatsby'

const MembershipTable = ({ slice }) => {
    return (
        <section className="membership-table">
            <div className="center-medium">
                <div className="membership-grid">
                    {slice.items.map((item, index) => (
                        <div className="membership-grid-row">
                            <div className="membership-grid-name">
                                {item.name.text}
                            </div>
                            <div className="membership-grid-description">
                                {item.description.text}
                            </div>
                            <div className="membership-grid-price">
                                {item.price.text}
                            </div>
                            <div className="membership-grid-button">
                                <Link to={item.enroll_link.url} className="button-solid">{item.enroll_text.text}</Link>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default MembershipTable